import { StationStatusListItem } from '@app/modules/logger/screens/status/types';
import { useMemo } from 'react';
import { useSortedStatuses } from './useSortedStatuses';

export interface StatusSectionsState {
  favorites: StationStatusListItem[];
  nonFavorites: StationStatusListItem[];
  visibleFavorites: StationStatusListItem[];
  visibleNonFavorites: StationStatusListItem[];
  showSections: boolean;
  hasVisibleStations: boolean;
}

/**
 * Derives section state from statuses: favorites vs others, visibility, and whether to show sections.
 * Used by both grid and list layouts to avoid duplicating sorting/filtering logic.
 */
export function useStatusSections(statuses: StationStatusListItem[]): StatusSectionsState {
  const { favorites, nonFavorites } = useSortedStatuses(statuses);

  return useMemo(() => {
    const visibleFavorites = favorites.filter((item) => item.isVisible);
    const visibleNonFavorites = nonFavorites.filter((item) => item.isVisible);
    const hasFavorites = favorites.length > 0;
    const hasVisibleStations = visibleFavorites.length > 0 || visibleNonFavorites.length > 0;

    return {
      favorites,
      nonFavorites,
      visibleFavorites,
      visibleNonFavorites,
      showSections: hasFavorites,
      hasVisibleStations,
    };
  }, [favorites, nonFavorites]);
}
